import axios from './axios'

export default axios.createApi({
  getUserInfo () {
    return axios.jsonp('http://video.qq.com/fcgi-bin/get_userinfo?otype=json&type=2&low_login=0')
  }
})
